<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto" />
  </form>
</template>
<script>
  export default {
    props: {
      interaction: {
        type: Object,
        default: () => {},
      },
    },

    data: () => ({
      loadingInteractions: false,
      filter: '',
      mentors: [],
      mentees: [],

    }),
  };
</script>